import FeedLayout from "layouts/files/FeedLayout";
import { useEffect, useRef, useState } from "react";
import { Geocoder, MapPagesHeader, SVG } from "ui";

import ReactMapGL, {
    GeolocateControl,
    NavigationControl,
    Source,
    Layer,
    MapRef,
    GeoJSONSource,
    MapLayerMouseEvent,
    Popup
} from "react-map-gl";
import "mapbox-gl/dist/mapbox-gl.css";
import { useSelector } from "react-redux";
import { RootState } from "services/redux/store";
import {
    clusterCountLayer,
    clusterLayer,
    unclusteredPointLayer
} from "ui/files/maps/layers";
import { Link } from "react-router-dom";
import { friendAvatar } from "utils/assets_exports/images";

export type PointFeature = {
    geometry: {
        coordinates: [number, number];
    };
    properties: {
        id: string;
        mag: number;
        time: number;
        felt: null | number;
        tsunami: number;
    };
};
const Map = () => {
    const [filter, setFilter] = useState("");
    // const mapRef = useRef(null);
    const [popupInfo, setPopupInfo] = useState<PointFeature | null>(null);
    const intialMapLocation = useSelector(
        (state: RootState) => state.site.locationLatLng
    );
    const [intitailViewState, setIntitailViewState] = useState({
        latitude: intialMapLocation.lat,
        longitude: intialMapLocation.lng,
        zoom: 2
    });

    useEffect(() => {
        console.log("intial map location updated", intialMapLocation);
        setIntitailViewState({
            ...intitailViewState,
            latitude: intialMapLocation.lat,
            longitude: intialMapLocation.lng
        });
    }, [intialMapLocation]);

    const mapRef = useRef<MapRef>(null);

    const onClick = (event: MapLayerMouseEvent): void => {
        console.group("map page");
        console.log("testing", event);
        if (!event.features) {
            return;
        }
        console.log("testing2", event.features);
        const feature = event.features[0];
        if (!feature || !feature.properties) {
            return;
        }
        const clusterId = feature.properties.cluster_id;
        clusterId
            ? console.log("cluster id", clusterId)
            : console.log("point id", feature.properties.id);
        console.groupEnd();

        if (!mapRef.current) {
            return;
        }

        if (clusterId) {
            const mapboxSource = mapRef.current.getSource(
                "earthquakes"
            ) as GeoJSONSource;

            mapboxSource.getClusterExpansionZoom(
                clusterId,
                (err, zoom: number) => {
                    if (err || !mapRef.current) {
                        return;
                    }

                    mapRef.current.easeTo({
                        // @ts-ignore
                        center: feature.geometry.coordinates,
                        zoom,
                        duration: 500
                    });
                }
            );
        } else {
            // @ts-ignore
            setPopupInfo(feature);
        }
    };

    const closePopup = (): void => {
        setPopupInfo(null);
    };

    return (
        <FeedLayout pageTitle="map">
            <div className="maps-pages">
                <MapPagesHeader
                    title="Map"
                    filterVal={filter}
                    setFilterVal={setFilter}
                    removeSearch
                />
                <div style={{ width: "100%", height: "70vh" }}>
                    <div
                        style={{
                            height: "100%",
                            width: "100%",
                            position: "relative"
                        }}
                    >
                        <ReactMapGL
                            interactiveLayerIds={[
                                unclusteredPointLayer.id || "",
                                clusterLayer.id || ""
                            ]}
                            onClick={onClick}
                            ref={mapRef}
                            mapboxAccessToken={
                                process.env.REACT_APP_GMAPBOX_API_KEY
                            }
                            initialViewState={intitailViewState}
                            mapStyle="mapbox://styles/mapbox/streets-v11"
                        >
                            <NavigationControl position="bottom-right" />
                            <GeolocateControl
                                positionOptions={{
                                    enableHighAccuracy: true
                                }}
                                trackUserLocation={true}
                                position="top-left"
                            />
                            <Geocoder />
                            <Source
                                id="earthquakes"
                                type="geojson"
                                data="https://docs.mapbox.com/mapbox-gl-js/assets/earthquakes.geojson"
                                cluster={true}
                                clusterMaxZoom={14}
                                clusterRadius={50}
                            >
                                <Layer {...clusterLayer} />
                                <Layer {...clusterCountLayer} />
                                <Layer {...unclusteredPointLayer} />
                            </Source>
                            {popupInfo && (
                                <Popup
                                    longitude={
                                        popupInfo.geometry.coordinates[0]
                                    }
                                    latitude={popupInfo.geometry.coordinates[1]}
                                    closeButton={true}
                                    closeOnClick={false}
                                    onClose={closePopup}
                                >
                                    <Link to="#">
                                        <div className="map-popup d-flex flex-col flex-a-center flex-j-center gap-5">
                                            <img
                                                src={friendAvatar}
                                                alt="User Name"
                                            />
                                            <div className="d-flex flex-col flex-a-start flex-j-center pl-10">
                                                <h3>
                                                    <p className="black-text white-text fw-500 fs-9em">
                                                        User Name
                                                    </p>
                                                </h3>
                                            </div>
                                            <div>
                                                <div className="momeento-p black-text white-text d-flex flex-j-start gap-5 flex">
                                                    <SVG
                                                        svg="map-pointer"
                                                        size={12}
                                                        className="red-svg"
                                                    />
                                                    <div>
                                                        <span>
                                                            this will be
                                                            replaced by adress
                                                            after connecting to
                                                            db:
                                                        </span>{" "}
                                                        <span>
                                                            {
                                                                popupInfo
                                                                    .properties
                                                                    .id
                                                            }
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {/* <h3>{popupInfo.properties.id}</h3>
                                        <p>
                                            Magnitude:{" "}
                                            {popupInfo.properties.mag}
                                        </p> */}
                                    </Link>
                                </Popup>
                            )}
                        </ReactMapGL>
                    </div>
                </div>
            </div>
        </FeedLayout>
    );
};

export default Map;
